module.exports = __webpack_public_path__ + "static/Beach-Final-compressed-ec59946c78aace0656304175a389140d.mp4";